import axios from "axios";
import {
  DASHBOARD_BASE_URL,
  USER_GRAPH_DATA_BASE_URL,
} from "shared/constants/backend";
import {
  AccessType,
  AppAccessResponse,
  Component,
  DashboardSummary,
  GroupsAndUsersResponse,
  UrsulaUserGraphDataRequest,
  UrsulaUserGraphDataResponse,
} from "shared/models";
import { generateAuthorizationHeaders } from "shared/utils";

export async function downloadSDK(token = "") {
  const headers = generateAuthorizationHeaders(token);
  headers["Accept"] = "application/zip";
  try {
    const response = await axios.get(`${DASHBOARD_BASE_URL}/download/`, {
      headers,
      responseType: "blob",
    });

    const contentDisposition = response.headers["content-disposition"] || "";
    const filename = contentDisposition
      ? contentDisposition.split("filename=")[1].replace(/"/g, "")
      : "speaker-sdk.zip";

    const blob: Blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();

    // Clean up the object URL
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error downloading the SDK file:", error);
  }
}

export async function getApplicationAccess(
  token = ""
): Promise<AppAccessResponse> {
  const headers = generateAuthorizationHeaders(token);

  const response = await axios.get<AppAccessResponse>(
    `${DASHBOARD_BASE_URL}/application-access/`,
    {
      headers,
    }
  );
  return response.data;
}

export async function getDashboardComponents(token = ""): Promise<Component[]> {
  const headers = generateAuthorizationHeaders(token);
  const response = await axios.get<Component[]>(
    `${DASHBOARD_BASE_URL}/components/`,
    {
      headers,
    }
  );
  return response.data;
}

export async function getHighestAccessType(token = ""): Promise<AccessType> {
  const headers = generateAuthorizationHeaders(token);

  const response = await axios.get<AccessType>(
    `${DASHBOARD_BASE_URL}/highest-access-type`,
    {
      headers,
    }
  );
  return response.data;
}

export async function getDashboardSummary(
  token = ""
): Promise<DashboardSummary> {
  const headers = generateAuthorizationHeaders(token);

  const response = await axios.get<DashboardSummary>(
    `${DASHBOARD_BASE_URL}/summary`,
    {
      headers,
    }
  );
  return response.data;
}

export async function getGroupsAndUsers(
  token = ""
): Promise<GroupsAndUsersResponse> {
  const headers = generateAuthorizationHeaders(token);

  const response = await axios.get<GroupsAndUsersResponse>(
    `${DASHBOARD_BASE_URL}/`,
    {
      headers,
    }
  );
  return response.data;
}

export async function getUserGraphData(
  request: UrsulaUserGraphDataRequest,
  token = ""
): Promise<UrsulaUserGraphDataResponse> {
  const headers = generateAuthorizationHeaders(token);

  const response = await axios.get<UrsulaUserGraphDataResponse>(
    `${USER_GRAPH_DATA_BASE_URL}`,
    {
      headers,
      params: request,
    }
  );
  return response.data;
}
